import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ApiService } from '../../core/api';
import { ResponseDatas } from '../../core/api/types';
import { ConfigService } from '../../core/config';

import { Company } from './types';

@Injectable({
  providedIn: 'root'
})
export class CompaniesService {
  private readonly apiService = inject(ApiService);
  private readonly configService = inject(ConfigService);

  addCompany(company: Company): Observable<Company> {
    const appToken = this.configService.get('appToken');

    return this.apiService.post<Company>('Companies', { ...company, appToken });
  }

  getCompaniesForOperator(): Observable<Company[]> {
    return this.apiService
      .get<ResponseDatas<Company[]>>('Companies/GetCompaniesForOperator')
      .pipe(map((result) => result?.datas));
  }

  getCompany(companyID: number): Observable<Company> {
    return this.apiService.get<Company>(`Companies/${companyID}`);
  }

  getPublicInformation(countryID: number, orgNumber: string): Observable<Company> {
    return this.apiService.get<Company>(`Companies/public-information/country/${countryID}/org-number/${orgNumber}`);
  }

  searchOrgInfo(text: string, countryID: number): Observable<Company[]> {
    const params = new HttpParams({ fromObject: { text, countryID } });

    return this.apiService.get<Company[]>('Companies/by-org-info', { params });
  }
}
